module.exports = __webpack_public_path__ + "static/media/wor_clo_to_wat_pon_cra.fe181ee6.png";